interface PreviewTableProps {
  columns: { name: string; uid: string }[];
  previewData: any[];
}

export const PreviewTable: React.FC<PreviewTableProps> = ({
  columns,
  previewData,
}) => {
  return (
    <div className='border rounded-lg overflow-hidden'>
      <div className='p-4 bg-default-100 border-b'>
        <h3 className='font-semibold'>Vista previa (primeras 5 filas)</h3>
      </div>
      <div className='overflow-x-auto'>
        <table className='min-w-full divide-y divide-divider'>
          <thead className='bg-default-100'>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.uid}
                  className='px-6 py-3 text-left text-xs font-medium text-default-400 uppercase tracking-wider'
                >
                  {column.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className='bg-background divide-y divide-divider'>
            {previewData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column) => (
                  <td
                    key={column.uid}
                    className='px-6 py-4 whitespace-nowrap text-sm text-foreground'
                  >
                    {row[column.uid]?.toString() || ''}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className='p-4 bg-default-100 border-t'>
        <p className='text-sm text-default-400'>
          * Los valores mostrados son una vista previa. Asegúrese de que los
          datos estén correctamente formateados en el archivo Excel.
        </p>
      </div>
    </div>
  );
};
